import { css, jsx } from '@emotion/react';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import { TypographyPDL } from '../../../theme/Typography.es.js';
import '../../../theme/ZinniaStylesReset.es.js';
import { labelStyles } from '@zapier/style-encapsulation';

const Styles = labelStyles("FormLabelRequiredText", {
  root: css`
    ${TypographyPDL("--zds-small-print-1", "smallPrint1")}
    color: var(--zds-text-default, ${Colors.neutral700});
    text-transform: lowercase;

    &::before {
      content: '(';
    }

    &::after {
      content: ')';
    }

    &[data-state='disabled'] {
      color: var(--zds-text-weakest, ${Colors.neutral500});
    }
  `
});
const FormLabelRequiredText = ({ children = "Required", isDisabled = false }) => {
  return (
    // `aria-hidden` to prevent it from being read redundantly.
    // The associated `input` field should indicate whether it's
    // required to screenreaders.
    jsx("span", { "aria-hidden": "true", css: Styles.root, "data-state": isDisabled ? "disabled" : void 0, "data-zds": true }, children)
  );
};

export { FormLabelRequiredText };
//# sourceMappingURL=FormLabelRequiredText.es.js.map
